import React from 'react'
import Moment from 'react-moment'
import { Grid, GridCol } from '../common/Grid'
import { List, ListItem } from '../common/List'
import Artist from '../artists/Artist'
import EvenimentDelete from '../eveniments/EvenimentDelete'
import Place from '../places/Place'

const EvenimentsList = props => (
    <List>
        {props.eveniments.map((event, idx) => (
            <ListItem key={idx}>
                <Grid className="has-vcenter">
                    <GridCol className="is-min">
                        <i className="material-icons">date_range</i>
                    </GridCol>
                    <GridCol>
                        <Moment format="DD MMMM YYYY" date={new Date(event.startdate)} />
                    </GridCol>
                    <GridCol>
                        <Place id={event.placeId} places={props.places} />
                    </GridCol>
                    <GridCol>
                        <Artist id={event.artistId} artists={props.artists} />
                    </GridCol>
                    <GridCol className="has-text-right">
                        <EvenimentDelete id={event.id} />
                    </GridCol>
                </Grid>
            </ListItem>
        ))}
    </List>
)

export default EvenimentsList


// WEBPACK FOOTER //
// ./src/components/eveniments/EvenimentsList.js